import type { DatesSetArg } from '@fullcalendar/core'
import { format } from 'date-fns'
import { de } from 'date-fns/locale'

export const MOBILE_CALENDAR_BREAKPOINT = 700
export const MEDIUM_CALENDAR_BREAKPOINT = 1030
export const DEFAULT_CALENDAR_WINDOW_WIDTH = 1200

export type ResponsiveCalendarView = 'timeGridDay' | 'timeGridWeek'

export type ResponsiveCalendarLayout = {
  calendarView: ResponsiveCalendarView
  visibleDays: 1 | 3 | 7
}

export function getInitialCalendarWindowWidth() {
  return typeof window !== 'undefined' ? window.innerWidth : DEFAULT_CALENDAR_WINDOW_WIDTH
}

export function getResponsiveCalendarLayout(windowWidth: number): ResponsiveCalendarLayout {
  if (windowWidth < MOBILE_CALENDAR_BREAKPOINT) {
    return { calendarView: 'timeGridDay', visibleDays: 1 }
  }

  if (windowWidth < MEDIUM_CALENDAR_BREAKPOINT) {
    return { calendarView: 'timeGridWeek', visibleDays: 3 }
  }

  return { calendarView: 'timeGridWeek', visibleDays: 7 }
}

export function getCalendarToolbarTitle(arg: DatesSetArg): string {
  if (arg.view.type === 'timeGridDay') {
    return format(arg.start, 'EEEE, d. MMMM yyyy', { locale: de })
  }

  if (arg.view.type === 'dayGridMonth') {
    return format(arg.start, 'MMMM yyyy', { locale: de })
  }

  return arg.view.title
}
